<template>
  <!-- <v-parallax dark
              class="parallax"
              :src="c.API_BASE_URL + '/background.jpg'"> -->
  <v-content>
    <v-container fill-height>
      <v-layout row justify-center align-center>
        <v-flex xs12 sm10 md8>
          <v-card>
            <v-card-media class="white--text primary" height="200px">
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="display-1 font-weight-bold"
                      >{{ sistem.app_title }}
                    </span>
                    <span class="headline">versi {{ sistem.app_version }}</span>
                    <div>
                      <span
                        >Selamat Datang <b>{{ profil.username }}</b
                        >, role akun Anda adalah <b>{{ profil.role }}</b
                        >, dengan hak akses <b>{{ profil.role_desc }}</b
                        >.
                      </span>
                    </div>
                    <div class="mt-4 subheading">- {{ sistem.company }}</div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-media>
            <v-card-text>
              <span
                >Silahkan pilih pengaturan umum untuk pertama kali.
                <v-icon>tag_faces</v-icon>
              </span>
              <v-subheader class="px-1"> Business Unit </v-subheader>
              <v-radio-group
                v-model="id_laman"
                class="ma-0 pa-0"
                row
                v-validate="'required'"
                name="id_laman"
                data-vv-name="id_laman"
                data-vv-as="Business Unit"
                :error-messages="errors.collect('id_laman')"
              >
                <v-radio
                  v-for="(item, i) in laman"
                  :key="i"
                  :value="item.id_laman"
                  :label="item.laman"
                >
                </v-radio>
              </v-radio-group>

              <v-subheader class="px-1"> Mode Pencahayaan </v-subheader>
              <v-radio-group
                v-model="lightOption"
                class="ma-0 pa-0"
                hide-details
                row
                mandatory
              >
                <v-radio value="dark" label="GELAP"> </v-radio>
                <v-radio value="light" label="TERANG"> </v-radio>
              </v-radio-group>

              <v-subheader class="px-1"> Pilihan Warna </v-subheader>
              <div class="color-option">
                <v-layout wrap>
                  <label
                    class="color-option--label flex xs4 sm3 md2 lg1 pa-1"
                    v-for="option in themeColorOptions"
                    :key="`color-options-${option.key}`"
                  >
                    <input
                      type="radio"
                      name="color"
                      :value="option.key"
                      v-model="themeColor"
                    />
                    <span class="color-option--item bg">
                      <span class="overlay">
                        <span class="material-icons">check</span>
                      </span>
                      <span
                        class="color-option--item--header sideNav"
                        :class="option.value.sideNav"
                      ></span>
                      <span
                        class="color-option--item--header mainNav"
                        :class="option.value.mainNav"
                      ></span>
                      <span
                        class="sideMenu"
                        :class="option.value.sideManu"
                      ></span>
                    </span>
                  </label>
                </v-layout>
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn dark large @click="start" color="primary">MULAI </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
  <!-- </v-parallax> -->
</template>

<script>
import c from "@/constants";
import colors from "vuetify/es5/util/colors";
import Themes from "@/constants/themes";
import { mapState } from "vuex";

export default {
  name: "welcome-screen",
  data() {
    return {
      colors: colors,
      themeColorOptions: Themes,
      id_laman: "",
      c: c
    };
  },
  computed: {
    ...mapState(["ui"]),
    ...mapState("sistem", ["sistem"]),
    ...mapState("auth", ["profil"]),
    ...mapState("laman", ["laman"]),
    themeColor: {
      get() {
        return this.ui.themeColor;
      },
      set(val) {
        this.$vuetify.theme.primary = this.colors[val].base;
        this.$vuetify.theme.secondary = this.colors[val].lighten2;
        this.$store.dispatch("SET_THEME_COLOR", val);
      }
    },
    lightOption: {
      get() {
        return this.ui.lightOption;
      },
      set(val) {
        this.$vuetify.dark = val === "dark";
        this.$store.dispatch("SET_LIGHT_OPTION", val);
      }
    }
  },
  methods: {
    start() {
      this.$validator.validateAll().then(noError => {
        if (noError) {
          this.$store.dispatch("SET_LAMAN", this.id_laman);
        } else {
          this.$store.commit(
            "ERROR",
            "Ada field yang masih error, cek kembali isian form!"
          );
        }
      });
    }
  }
};
</script>

<style scoped>
.color-option--label {
  position: relative;
  display: block;
  cursor: pointer;
}
.color-option--label input[type="radio"] {
  display: none;
}
.color-option--label input[type="radio"] + span {
  position: relative;
}
.color-option--label input[type="radio"] + span > .overlay {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  text-align: center;
  line-height: 30px;
  color: #fff;
}
.color-option--label input[type="radio"]:checked + span > .overlay {
  display: block;
}
.color-option--label .bg {
  background-color: #f1f1f1;
}
.color-option--item {
  overflow: hidden;
  display: block;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
}
.color-option--item--header {
  height: 10px;
}
.color-option--item > span {
  display: block;
  float: left;
  width: 50%;
  height: 20px;
}
</style>
